import { type SelectHTMLAttributes, forwardRef } from "react";
import { cn } from "./utils/cn";

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ invalid, className, children, ...rest }, ref) => (
    <select
      ref={ref}
      className={cn("hui-select", invalid && "hui-select--error", className)}
      {...rest}
    >
      {children}
    </select>
  )
);

Select.displayName = "Select";
